"use strict";

define('libs/color',['underscore'], function (_) {
  var Color = {
    Status: function Status(value) {
      var color = 'dark grey';
      switch (String(value || '').toLowerCase()) {
        case 'disapproved':
        case 'suspended':
        case 'expired':
          color = 'red';
          break;
        case 'unsubmitted':
          color = 'pink';
          break;
        case 'closed':
        case 'legacy':
          color = 'black';
          break;
        case 'approved':
        case 'review complete':
          color = 'green';
          break;
        case 'requires changes':
          color = 'purple';
          break;
        case 'under pre-review':
        case 'under review':
        case 'under post review':
          color = 'orange';
          break;
        case 'submitted':
          color = 'blue';
          break;
        case 'withdrawn':
          color = 'dark teal';
          break;
      }
      return color;
    }
  };
  return Color;
});

